/*****
 * Created with vscode
 * Name : 输入搜索框
 * Date : 2020/2/27
 * Author : Bevis Shen
 * Func :
 *  placeholder: 输入的默认文字
 *  injectFocus: 是否聚焦
 *  inputColor: 输入框颜色
 *  on-change: 输入的信息变化时回调
 *  on-search: 搜索时回调
 *  on-clear: 清空时回调
 *  on-blur: 光标移开时回调
 *  on-focus: 光标聚焦时回调
 *  on-input: 输入时回调
 ******/

<template>
  <div class="layout-search-input">
    <div
      class="search-cont"
      :class="[{focus: injectFocus}, inputColor]"
    >
      <div class="input-wrap">
        <input
          type="text"
          name="search"
          v-model="content"
          autocomplete="off"
          :placeholder="placeholder"
          @change="change"
          @focus="focus"
          @blur="blur"
          @input="input"
        />
      </div>
      <img
        v-show="content.length"
        class="clear-input"
        @click.stop="clear"
        src="../../assets/images/jidayi-hospital/icon-search-close.png"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchInput',
  props: {
    placeholder: {
      type: String,
      default: '请输入搜索内容'
    },
    injectFocus: {
      type: Boolean,
      default: false
    },
    inputColor: {
      type: String,
      default: 'gray'
    }
  },
  data () {
    return {
      content: '',
      isFocus: this.injectFocus
    }
  },
  methods: {
    input () {
      this.isFocus = true
      this.$emit('on-input', this.content)
    },
    focus () {
      this.isFocus = true
      this.$emit('on-focus')
    },
    blur () {
      this.$emit('on-blur')
    },
    clear () {
      this.content = ''
      this.blur()
      this.$emit('on-clear', this.content)
    },
    search (val) {
      if (val) {
        this.content = val
      }

      if (!this.content) {
        return false
      }

      this.$emit('on-search', this.content)
    },
    change () {
      this.isFocus = false
      this.$emit('on-change', this.content)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/SearchInput.vue